import { Component, OnDestroy, OnInit } from '@angular/core';
import { AutenticacionService } from '../../_services/autenticacion.service';

/**
 * Muestra Página para el error 401 (Sin Permisos) sobre la funcionalidad
 */
@Component( {
  selector: 'app-unica-sesion',
  templateUrl: 'unicaSesion.component.html',
} )
export class UnicaSesionComponent implements OnInit, OnDestroy {

  constructor(
    private authenticationService: AutenticacionService
  ) {
  }

  /**
   * Función de Inicio de la funcionalidad
   */
  ngOnInit(): void {
    $( 'body' ).addClass( 'page-one-session' );
    // this.authenticationService.cerrarSesion();
  }

  /**
   * Función que se ejecuta al salir de la funcionalidad
   */
  ngOnDestroy() {
    $( 'body' ).removeClass( 'page-one-session' );
  }

  cerrarTab() {

  }

  cerrarSession() {

  }
}
